module.exports = __webpack_public_path__ + "static/media/preset-card-expand.9c46e1f6.gif";